<template>
  <section v-if="products.length > 0" class="section">
    <div class="container-lg">
      <div class="section__header">
        <h2 class="section__title">{{ in18['page_recently_bought'] }}</h2>
      </div>
      <div class="row  slider-no-dots" data-mobile-slider>
        <div v-for="product in products" class="col-md-3">
          <product-item :product="product"></product-item>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>
</template>

<script>
export default {
  name:  "RecentlyBoughtProducts",
  props: [
    'in18',
    'products'
  ],
}
</script>